import { Observable } from "rxjs";
import { inject, injectable } from "tsyringe";
import { HttpClient } from "src/infra/http/client";
import { autoBind } from "src/shared/decorators/autobind";

@injectable()
export class RepaymentObligationsRepository {
    constructor(@inject("HttpClient") private http: HttpClient) {}

    @autoBind
    getObligations(): Observable<Array<object>> {
        const headers = this.http.httpUtils.getMsBaseHeaders(
            window.userIdentity,
            "MEP"
        );
        const endpoint = RepaymentObligationsRepository.getObligationsUrl();
        return this.http.getJSON<object[]>(endpoint, {
            isPublicRequest: false,
            customHeader: {
                ...this.http.httpUtils.getBaseHeaders(),
                ...headers,
            },
        });
    }

    static getObligationsUrl() {
        return "insureds/me/requests/insured-repayment-obligations";
    }
}
